// typescript version of
// https://github.com/algm/reactstrap-confirm/blob/master/src/components/ConfirmModal.js
import { __assign, __read } from "tslib";
import { Formik } from 'formik';
import React, { useState } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
export var DialogModal = function (_a) {
    var onClose = _a.onClose, initialValue = _a.initialValue, body = _a.body, title = _a.title, confirmText = _a.confirmText, cancelText = _a.cancelText, confirmColor = _a.confirmColor, cancelColor = _a.cancelColor, className = _a.className, buttonsComponent = _a.buttonsComponent, size = _a.size;
    var _b = __read(useState(initialValue), 1), state = _b[0];
    var _cancelClick = function () { return onClose({ result: false, value: state }); };
    var Body = body;
    var buttonsContent = function (formProps) {
        if (buttonsComponent) {
            var CustomComponent = buttonsComponent;
            return React.createElement(CustomComponent, { onClose: onClose });
        }
        else {
            return (React.createElement(React.Fragment, null,
                cancelText && (React.createElement(Button, { color: cancelColor, onClick: _cancelClick }, cancelText)),
                ' ',
                React.createElement(Button, { type: "submit", color: confirmColor, onClick: function () { return formProps.submitForm(); } }, confirmText)));
        }
    };
    return (React.createElement(Formik, { initialValues: state, onSubmit: function (values, helpers) {
            onClose({ result: true, value: values, helpers: helpers });
        } }, function (formProps) { return (React.createElement(Modal, { size: size, isOpen: true, toggle: _cancelClick, className: className },
        title && React.createElement(ModalHeader, { toggle: _cancelClick }, title || null),
        React.createElement(ModalBody, null,
            React.createElement(Body, __assign({}, formProps))),
        React.createElement(ModalFooter, null, buttonsContent(formProps)))); }));
};
DialogModal.defaultProps = {
    confirmText: 'Ok',
    cancelText: 'Cancel',
    confirmColor: 'primary',
    cancelColor: '',
    className: '',
    buttonsComponent: null,
    size: null
};
export var openDialog = function (props) {
    return new Promise(function (resolve) {
        var el = document.createElement('div');
        var handleResolve = function (result) {
            if (el) {
                unmountComponentAtNode(el);
                el = null;
                resolve(result);
            }
        };
        render(React.createElement(DialogModal, __assign({}, props, { onClose: handleResolve })), el);
    });
};
//# sourceMappingURL=DialogModal.js.map